const baseURLS = {
    events: '/event/configuration/',
    eventsCC: '/event/cost_center/',
    eventsPJ: '/event/project/',
    travel: '/travel/',
    companyProject: 'configuration/project/',
    company: '/company/',
    companyCostCenter: 'configuration/cost_center/',
    payments: {
        requester: '/payment/requester',
        approver: '/payment/approver',
        payer: '/payment/payer',
    },
    configuration: '/configuration',
    industrialStorage: '/paper_storage',
}

/**
 * Definição dos endpoints da API
 * Cada endpoint possui suas configurações específicas:
 * - url: caminho do endpoint
 * - metodo: método HTTP utilizado
 * - publico: indica se requer autenticação
 * - cache: indica se a resposta pode ser cacheada
 * - timeout: timeout específico para o endpoint
 * - retry: número de tentativas em caso de falha
 */
export const endpoints = {
    /**
     * Endpoints de autenticação
     */
    login: {
        url: '/login',
        metodo: 'post',
        publico: true,
    },
    registrar: {
        url: '/auth/registrar',
        metodo: 'post',
        publico: true,
    },
    recuperarSenha: {
        // url: '/auth/recuperar-senha',
        url: '/resetpassword/',
        metodo: 'post',
        publico: true,
    },
    resetarSenha: {
        url: '/resetpassword',
        metodo: 'post',
        publico: true,
    },
    refreshToken: {
        url: '/refresh-token',
        metodo: 'post',
        publico: true,
    },
    /**
     * Endpoints de gerenciamento de usuário
     */
    obterPerfil: {
        url: '/profile',
        metodo: 'get',
        publico: false,
    },
    atualizarPerfil: {
        url: '/profile/update',
        metodo: 'post',
        publico: false,
    },
    atualizarAvatar: {
        url: '/profile/avatar/update',
        metodo: 'post',
        publico: false,
    },
    getAvatar: {
        url: '/profile/avatar',
        metodo: 'get',
        publico: false,
    },
    removeAvatar: {
        url: '/profile/avatar/remove',
        metodo: 'post',
        publico: false,
    },
    registrarUsuarioConvidado: {
        url: '/sign_up/invite', // ajuste se o backend tiver outro nome
        metodo: 'post',
        publico: true,
    },
    enviarConvite: {
        url: '/user_management/invite_user', // ajuste se o backend tiver outro nome
        metodo: 'post',
        publico: false,
    },
    acceptInvite: {
        url: '/user_management/accept_invite',
        metodo: 'post',
        publico: false,
    },
    /**
     * Endpoints para gerenciamento de companhia
     */
    registrarCompanhia: {
        url: '/sign_up/admin',
        metodo: 'post',
        publico: true,
    },
    updateLogoCompany: {
        url: 'configuration/company/update_logo/',
        metodo: 'post',
        publico: false,
    },
    removeLogoCompany: {
        url: 'configuration/company/remove_logo/',
        metodo: 'post',
        publico: false,
    },
    getCompanyData: {
        url: baseURLS.configuration + '/company/find/',
        metodo: 'get',
        publico: false,
    },
    updateCompany: {
        url: baseURLS.configuration + '/company/update/',
        metodo: 'post',
        publico: false,
    },
    updateStatusCompany: {
        url: baseURLS.configuration + '/company/update_status/',
        metodo: 'post',
        publico: false,
    },
    changeCompany: {
        url: '/change_company',
        metodo: 'post',
        publico: false,
    },
    getProjectAndCostCenter: {
        url: baseURLS.configuration + '/company/get_project_cost_center/',
        metodo: 'get',
        publico: false,
    },
    createApiClientRole: {
        url: baseURLS.configuration + '/role/api_client/',
        metodo: 'post',
        publico: false,
    },
    createApiClientUser: {
        url: '/api_clients/new',
        metodo: 'post',
        publico: false,
    },
    updateApiClientUser: {
        url:'/api_clients/update/',
        metodo: 'post',
        publico: false,
    },
    regenerateApiClientToken: {
        url: '/api_clients/regenerate_token/',
        metodo: 'post',
        publico: false,
    },
    deleteApiClientUser: {
        url: '/api_clients/delete/',
        metodo: 'delete',
        publico: false,
    },

    // Cost Center Endpoints
    indexByCompanyCostCenter: {
        url: baseURLS.companyCostCenter + 'all/',
        metodo: 'GET',
        publico: false,
    },
    getCostCenterByCompanyAndId: {
        url: baseURLS.companyCostCenter + 'get/',
        metodo: 'GET',
        publico: false,
    },
    cancelCostCenter: {
        url: baseURLS.companyCostCenter + 'disable/',
        metodo: 'GET',
        publico: false,
    },
    deleteCostCenter: {
        url: baseURLS.companyCostCenter + 'delete/',
        metodo: 'POST',
        publico: false,
    },
    storeCostCenter: {
        url: baseURLS.companyCostCenter + 'create',
        metodo: 'POST',
        publico: false,
    },
    updateCostCenter: {
        url: baseURLS.companyCostCenter + 'update/',
        metodo: 'POST',
        publico: false,
    },
    updateParentLevelCostCenter: {
        url: baseURLS.companyCostCenter + 'cost/',
        metodo: 'POST',
        publico: false,
    },


    listEventsByCompany: {
        url: baseURLS.events + 'list_by_company/', // Requer /company_id
        metodo: 'get',
        publico: false,
    },
    getEventById: {
        url: baseURLS.events + 'find/', // Requer /company_id/id
        metodo: 'get',
        publico: false,
    },
    createEvent: {
        url: baseURLS.events + 'new',
        metodo: 'post',
        publico: false,
    },
    updateEvent: {
        url: baseURLS.events + 'update/',
        metodo: 'put',
        publico: false,
    },
    deleteEvent: {
        url: baseURLS.events + 'delete_event/',
        metodo: 'delete',
        publico: false,
    },
    uploadEventBanner: {
        url: baseURLS.events + 'upload_banner/',
        metodo: 'post',
        publico: false,
    },
    deleteEventBanner: {
        url: baseURLS.events + 'delete_banner/',
        metodo: 'delete',
        publico: false,
    },
    getOrganizers: { url: baseURLS.events + 'get_organizers/', metodo: 'get' },
    getEventCostCenters: { url: baseURLS.eventsCC + 'all/', metodo: 'get' },
    getEventProjects: { url: baseURLS.eventsPJ + 'all/', metodo: 'get' },

    /**
     * Endpoints de Requisição de Marketing
     */
    createMarketingRequest: {
        url: baseURLS.events + 'new_marketing',
        metodo: 'post',
        publico: false,
    },
    updateMarketingRequest: {
        url: baseURLS.events + 'update_marketing/',
        metodo: 'post',
        publico: false,
    },
    listAllMarketingRequests: {
        url: baseURLS.events + 'list_all_marketing',
        metodo: 'get',
        publico: false,
    },
    deleteMarketingRequest: {
        url: baseURLS.events + 'delete_marketing/',
        metodo: 'delete',
        publico: false,
    },
    uploadMarketingFiles: {
        url: baseURLS.events + 'upload_files/',
        metodo: 'post',
        publico: false,
    },

    deleteMarketingFile: {
        url: baseURLS.events + 'delete_file/',
        metodo: 'delete',
        publico: false,
    },

    getMarketingRequestByEvent: {
        url: baseURLS.events + 'marketing_by_event/',
        metodo: 'get',
        publico: false,
    },

    getEventAccessListBase: {
        url: baseURLS.events + 'access_list/',
        metodo: 'get',
        publico: false,
    },
    getEventAccessList: {
        url: baseURLS.events + 'access_list/',
        metodo: 'get',
        publico: false,
    },
    notifyMarketingResponsible: {
        url: baseURLS.events + 'notify_responsible',
        metodo: 'post',
        publico: false,
    },

    /**
     * Endpoints de Avaliação Pós-Evento
     */
    getPostEventData: {
        url: baseURLS.events + 'find_after/',
        metodo: 'get',
        publico: false,
    },
    createPostEventData: {
        url: baseURLS.events + 'new_after',
        metodo: 'post',
        publico: false,
    },
    updatePostEventData: {
        url: baseURLS.events + 'update_after/',
        metodo: 'put',
        publico: false,
    },

    /**
     * Endpoints para gerenciamento dos projetos da companhia
     */
    getAllProjects: {
        url: baseURLS.companyProject + 'all/',
        metodo: 'get',
        publico: false,
    },
    getProjectById: {
        url: baseURLS.companyProject + 'get/',
        metodo: 'get',
        publico: false,
    },
    createProject: {
        url: baseURLS.companyProject + 'create',
        metodo: 'post',
        publico: false,
    },
    editProject: {
        url: baseURLS.companyProject + 'update/',
        metodo: 'post',
        publico: false,
    },
    disableProject: {
        url: baseURLS.companyProject + 'disable/',
        metodo: 'post',
        publico: false,
    },
    deleteProject: {
        url: baseURLS.companyProject + 'delete/',
        metodo: 'post',
        publico: false,
    },
    copyProject: {
        url: baseURLS.companyProject + 'copy/',
        metodo: 'post',
        publico: false,
    },

    // Endpoints para Diário de Viagem

    listRequestedTravels: {
        url: baseURLS.travel + 'requester/list_requested',
        metodo: 'get',
        publico: false,
    },
    listApprovedTravels: {
        url: baseURLS.travel + 'approver/list_approved',
        metodo: 'get',
        publico: false,
    },
    getTravelById: { // Adicionado para buscar uma viagem específica
        url: baseURLS.travel + "requester/find/",
        metodo: 'get',
        publico: false,
    },
    getApprovedTravelById: {
        url: baseURLS.travel + "approver/find/",
        metodo: 'get',
        publico: false,
    },
    listTravelsByCompany: {
        url: baseURLS.travel + 'requester/list_by_company/', // Requer /company_id
        metodo: 'get',
        publico: false,
    },
    createNewTravel: {
        url: baseURLS.travel + 'requester/new_travel',
        metodo: 'post',
        publico: false,
    },
    updateTravelWithItems: {
        url: baseURLS.travel + 'requester/update_travel_with_items/', // Requer /travel_id
        metodo: 'post',
        publico: false,
    },
    updateTravelStatus: {
        url: baseURLS.travel + 'requester/update_status/',
        metodo: 'post',
        publico: false,
    },
    updateTravelStatusApprover: {
        url: baseURLS.travel + 'approver/update_status/',
        metodo: 'post',
        publico: false,
    },
    duplicateTravel: {
        url: baseURLS.travel + 'requester/duplicate_travel/', // Requer /id
        metodo: 'post',
        publico: false,
    },
    deleteTravel: {
        url: baseURLS.travel + "requester/delete/", // A URL base é /travel/, o ID será adicionado
        metodo: 'delete',
        publico: false,
    },
    // Endpoints para os itens da viagem (os "dias")
    updateTravelItem: {
        url: baseURLS.travel + 'requester/update_travel_item/', // Requer /travel_id/id
        metodo: 'post',
        publico: false,
    },
    deleteTravelItem: {
        url: baseURLS.travel + 'requester/delete_travel_item/', // Requer /travel_id/id
        metodo: 'delete',
        publico: false,
    },
    updateItemComment: {
        // Adicionado
        url: baseURLS.travel + 'requester/update_comment/', // Requer /id do item
        metodo: 'post',
        publico: false,
    },
    listAllUsersByAprovedTravel: {
        url: baseURLS.travel + 'requester/get_approver',
        metodo: 'get',
        publico: false,
    },
    storeProblemComment: {
        url: baseURLS.travel + 'approver/problem_comment/',
        metodo: 'post',
        publico: false,
    },

    /**
     * Endpoints para gerenciamento de pagamentos
     */
    getAllPayments: {
        url: baseURLS.payments.requester + '/list_requested',
        metodo: 'get',
        publico: false,
    },
    getAllPaymentsApprover: {
        url: baseURLS.payments.approver + '/list_approved',
        metodo: 'get',
        publico: false,
    },
    getAllPaymentsPayer: {
        url: baseURLS.payments.payer + '/list_payed',
        metodo: 'get',
        publico: false,
    },
    getApproverandFinancier: {
        url: baseURLS.payments.requester + '/get_accesses',
        metodo: 'get',
        publico: false,
    },
    createNewPayment: {
        url: baseURLS.payments.requester + '/new_financial_control',
        metodo: 'post',
        publico: false,
    },
    updatePaymentWithItems: {
        url: baseURLS.payments.requester + '/update_control_and_items/', //requer id
        metodo: 'post',
        publico: false,
    },
    previewFileRequester: {
        url: '/payment/requester/preview/',
        metodo: 'get',
        publico: false,
    },
    previewFileApprover: {
        url: '/payment/approver/preview/',
        metodo: 'get',
        publico: false,
    },
    previewFilePayer: {
        url: '/payment/payer/preview/',
        metodo: 'get',
        publico: false,
    },
    getPaymentById: {
        url: baseURLS.payments.requester + '/find/', //requer id
        metodo: 'get',
        publico: false,
    },
    duplicatePayment: {
        url: baseURLS.payments.requester + '/duplicate/', //requer id
        metodo: 'post',
        publico: false,
    },
    deletePayment: {
        url: baseURLS.payments.requester + '/delete/', //requer id
        metodo: 'delete',
        publico: false,
    },
    updatePaymentStatus: {
        url: baseURLS.payments.requester + '/update_status/', //requer id
        metodo: 'post',
        publico: false,
    },
    updatePaymentStatusApprover: {
        url: baseURLS.payments.approver + '/update_status/', // Rota específica do approver
        metodo: 'post',
        publico: false,
    },
    updatePaymentStatusPayer: {
        url: baseURLS.payments.payer + '/update_status/',
        metodo: 'post',
        publico: false,
    },
    updatePaymentItemComment: {
        // Adicionado
        url: baseURLS.payments.requester + '/update_comment/', // Requer /id do item
        metodo: 'post',
        publico: false,
    },
    updatePaymentItemCommentApprover: {
        url: baseURLS.payments.approver + '/update_comment/', // Rota específica do approver
        metodo: 'post',
        publico: false,
    },
    updatePaymentItemCommentPayer: {
        url: baseURLS.payments.payer + '/update_comment/', // Rota específica do payer (financial)
        metodo: 'post',
        publico: false,
    },
    updatePaymentItemStatus: {
        url: '/payment/approver/update_item_status/', // Usando a rota de aprovador, requer o ID do item
        metodo: 'post',
        publico: false,
    },
    updatePaymentItemStatusPayer: {
        url: '/payment/payer/update_item_status/', // Rota específica para o pagador
        metodo: 'post',
        publico: false,
    },
    deletePaymentFile: {
        url: baseURLS.payments.requester + '/delete_item_file/', // Usa a rota do requester
        metodo: 'delete',
        publico: false,
    },

    /**
     * Endpoints para utilizacao de "system_role" = "super"
     */
    buscarEmpresas: {
        url: 'configuration/company/list',
        metodo: 'get',
        publico: false,
    },
    getAllUsers: {
        url: 'configuration/user_management/list_all',
        metodo: 'get',
        publico: false,
    },
    listAllUsersByCompany: {
        url: 'configuration/user_management/list_by_company/',
        metodo: 'get',
        publico: false,
    },

    getUserByUuid: {
        url: '/configuration/user_management/find_user/',
        metodo: 'post',
        publico: false,
    },
    getRolesByCompany: {
        url: baseURLS.configuration + '/role_access/find/companyId/',
        metodo: 'get',
        publico: false,
    },
    updateRoleCompany: {
        url: baseURLS.configuration + '/user_management/role_company_update',
        metodo: 'post',
        publico: false,
    },
    updateStatusUser: {
        url: baseURLS.configuration + '/user_management/update_user_status',
        metodo: 'post',
        publico: false,
    },
    find_user_invite: {
        url: '/find_user_invite',
        metodo: 'post',
        publico: false,
    },
    changeUserPassword: {
        url: '/user/change_password/',
        metodo: 'post',
        publico: false,
    },
    updateInviteUser: {
        url: '/user_management/update_invite_user',
        metodo: 'post',
        publico: false,
    },

    /**
     * INDUSTRIAL STORAGE (BOBINAS E SETORES)
     */

    // Setores (Estoques)
    listSectors: {
        url: baseURLS.industrialStorage + '/sectors/',
        metodo: 'get',
        publico: false,
    },
    getSector: {
        url: baseURLS.industrialStorage + '/sectors/',
        metodo: 'get',
        publico: false,
    },
    createSector: {
        url: baseURLS.industrialStorage + '/sectors/',
        metodo: 'post',
        publico: false,
    },
    updateSector: {
        url: baseURLS.industrialStorage + '/sectors/',
        metodo: 'put',
        publico: false,
    },

    // Itens (Bobinas)
    getFilterData: {
        url: baseURLS.industrialStorage + '/items/filter_data/',
        metodo: 'get',
        publico: false,
    },
    listItems: {
        url: baseURLS.industrialStorage + '/items/',
        metodo: 'get',
        publico: false,
    },
    getItem: {
        url: baseURLS.industrialStorage + '/items/',
        metodo: 'get',
        publico: false,
    },
    showByCode: {
        url: baseURLS.industrialStorage + '/items/by_code/',
        metodo: 'get',
        publico: false,
    },
    createItem: {
        url: baseURLS.industrialStorage + '/items/',
        metodo: 'post',
        publico: false,
    },
    updateItem: {
        url: baseURLS.industrialStorage + '/items/',
        metodo: 'put',
        publico: false,
    },

    // Movimentações
    getItemHistory: {
        url: baseURLS.industrialStorage + '/movements/by_item/',
        metodo: 'get',
        publico: false,
    },
    createMovement: {
        url: baseURLS.industrialStorage + '/movements/',
        metodo: 'post',
        publico: false,
    },
    listActiveSectors: {
        url: baseURLS.industrialStorage + '/sectors/active',
        metodo: 'get',
        publico: false,
    },
    exportItems: {
        url: baseURLS.industrialStorage + '/export/items',
        metodo: 'get',
        publico: false,
    },
    importItems: {
        url: baseURLS.industrialStorage + '/import/items',
        metodo: 'post',
        publico: false,
    },
    itemReentry: {
        url: baseURLS.industrialStorage + '/items/reentry/',
        metodo: 'post',
        publico: false,
    },

    /**
     * Endpoints de Banco de Dados Externo (Tenant Database)
     */
    listTenantDatabases: {
        url: '/tenant_database/',
        metodo: 'get',
        publico: false,
    },
    getTenantDatabase: {
        url: '/tenant_database/',
        metodo: 'get',
        publico: false,
    },
    createTenantDatabase: {
        url: '/tenant_database/',
        metodo: 'post',
        publico: false,
    },
    updateTenantDatabase: {
        url: '/tenant_database/',
        metodo: 'post',
        publico: false,
    },
    deleteTenantDatabase: {
        url: '/tenant_database/',
        metodo: 'delete',
        publico: false,
    },
    weightCalc: {
        url: baseURLS.industrialStorage + '/items/weightCalc',
        metodo: 'post',
        publico: false,
    },
}
